import React, { useState } from 'react';
import TaskFrequencyDueView from '../view/TaskFrequencyDueView';
import TaskFrequencyOverdueView from '../view/TaskFrequencyOverdueView';

const TaskFrequencyEngine = ({ type }) => {
  const [count, setCount] = useState(1);
  const [repeat, setRepeat] = useState('');
  const [repeatEnd, setRepeatEnd] = useState('');
  const [repeatEndDays, setRepeatEndDays] = useState(null);
  const [onDueDate, setOnDueDate] = useState(true);
  const [reminders, setReminders] = useState([]);
  const updateReminderCount = (i, val) => {
    const newReminders = [...reminders];
    newReminders[i].reminderCount = val;
    setReminders(newReminders);
  };
  const updateReminderUnit = (i, val) => {
    const newReminders = [...reminders];
    newReminders[i].reminderUnit = val;
    setReminders(newReminders);
  };
  const onToggleOnDueDate = () => {
    setOnDueDate(!onDueDate);
  };
  const onAddReminderClicked = () => {
    const newReminders = [
      ...reminders,
      { reminderCount: 1, reminderUnit: 'days' }
    ];
    setReminders(newReminders);
  };
  const deleteReminder = i => {
    let newReminders = [...reminders];
    newReminders = newReminders.filter((o, index) => index !== i);
    setReminders(newReminders);
  };
  const viewProps = {
    count,
    deleteReminder,
    updateReminderCount,
    updateReminderUnit,
    onAddReminderClicked,
    onDueDate,
    onToggleOnDueDate,
    setCount,
    reminders,
    repeat,
    setRepeat,
    repeatEnd,
    setRepeatEnd,
    repeatEndDays,
    setRepeatEndDays
  };

  if (type === 'due') {
    return <TaskFrequencyDueView {...viewProps} />;
  } else {
    return <TaskFrequencyOverdueView {...viewProps} />;
  }
};

export default TaskFrequencyEngine;
